import { createGlobalStyle } from 'styled-components';

export const MainGlobalStyles = createGlobalStyle`
body {
  padding: 0;
  font-family: "TTCommons", sans-serif;
}

* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

p,
h1,
h2,
h3,
h4 {
  margin: 0;
  padding: 0;
}
`;
